const BOOKING_URL =
  "/book";

const sidebarQuotes = [
  {
    quote:
      "My website has graduated from 'start up vibes' into 'established business.' I'm astonished by how much we were able to accomplish in a day.",
    name: "Dave S.",
    highlight: "graduated from 'start up vibes' into 'established business.'",
  },
  {
    quote:
      "Just booked my first speaking gig from the website!",
    name: "Beatrice W.",
    highlight: "Just booked my first speaking gig from the website!",
  },
];

function HighlightedQuote({ quote, highlight }: { quote: string; highlight: string }) {
  const idx = quote.indexOf(highlight);
  if (idx === -1) return <>{quote}</>;
  const before = quote.slice(0, idx);
  const after = quote.slice(idx + highlight.length);
  return (
    <>
      {before}
      <span className="rounded bg-primary/20 px-1 text-foreground">{highlight}</span>
      {after}
    </>
  );
}

export function BlogSidebar() {
  return (
    <aside aria-label="Sidebar" className="space-y-6 lg:sticky lg:top-24 lg:self-start">
      <div className="space-y-4">
        <p className="text-xs font-bold uppercase tracking-wider text-primary">
          Coach website wins
        </p>
        {sidebarQuotes.map((t) => (
          <figure
            key={t.name}
            className="rounded-2xl border border-border bg-card p-5 shadow-card-soft"
          >
            <span
              aria-hidden="true"
              className="block text-6xl font-black leading-[0.7] text-primary"
              style={{ fontFamily: "'Poppins', system-ui, sans-serif" }}
            >
              &ldquo;
            </span>
            <blockquote className="mt-1 text-sm leading-relaxed text-foreground/85">
              <HighlightedQuote quote={t.quote} highlight={t.highlight} />
            </blockquote>
            <figcaption className="mt-3 text-xs font-semibold text-muted-foreground">
              {t.name}
            </figcaption>
          </figure>
        ))}
      </div>

      <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-secondary p-6 text-secondary-foreground shadow-card-soft">
        <div
          aria-hidden
          className="pointer-events-none absolute -top-16 -right-16 h-48 w-48 rounded-full bg-primary/30 blur-3xl"
        />
        <div className="relative">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary/15 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-primary">
            Coach website design
          </span>
          <h3 className="mt-4 text-2xl font-bold leading-tight text-white">
            Attract leads &amp; <span className="text-primary">convert clients</span>
          </h3>
          <p className="mt-3 text-sm text-white/70">
            You shouldn't have to wait for weeks or pay thousands for a coach website that works.
          </p>
          <ul className="mt-4 space-y-2 text-sm text-white/85">
            <li className="flex items-center gap-2">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary" />
              Live in 3 days
            </li>
            <li className="flex items-center gap-2">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary" />
              100% custom design
            </li>
            <li className="flex items-center gap-2">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary" />
              Strategic, multi-page sites
            </li>
          </ul>
          <a
            href={BOOKING_URL}
            className="mt-5 inline-flex items-center gap-1.5 rounded-full bg-primary-gradient px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-glow transition hover:opacity-90"
          >
            Start Today <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </aside>
  );
}
